module.exports = __webpack_public_path__ + "static/media/03-text.94a6912b.png";